define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/invitations',
    url: function(){
      var url = this.urlRoot;
      if ( !this.isNew() && (this.cancelledDateTime && this.cancelledDateTime != null)
      || (this.sentDateTime && this.sentDateTime != null) || (this.acceptedDateTime && this.acceptedDateTime != null) || (this.acceptedBy && this.acceptedBy != null)) {
          url += '/' + this.id;
      } else if ( this.id && this.id > 1 ) {
          url += '/' + this.id;
          if (this.invitationCode && this.invitationCode.length > 1) {
            url += '/' + "?UrlParam=" + this.encodeComponent(this.invitationCode);
          }
      }

      return url;
    },
  });
});
